import 'babel-polyfill'

const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    console.log('run')
  }
}

export { onClientEntry }
